import styles from "./FilterMenu.module.css"
import { ChevronDown, ChevronUp } from "lucide-react";
import { useEffect, useState } from 'react';
import FilterOptionCard from "../FilterCard/FilterCard";
import { filterMenuProps } from "../../../../types/tag";
import { useFilterContext } from "../../../../context/FilterContext";
import { useWindowSize } from "../../../../hooks/useWindowSize";

/**
* A filter menu for one filter category
*
* @param props FilterMenu props
* @param {string} props.title - Filter category title
* @param {keyof FilterDataProps} props.slug - Filter category slug
* @param {tagOption[]} props.tags - Filter category options
* @param {(key: keyof FilterDataProps, val: string[]) => void} props.setFilters - Filter set handler
* @param {boolean} props.filterOpen - Whether the menu is open
* @returns TSX.Element
*/
const FilterMenu = ({ title, slug, tags, setFilters, filterOpen } : filterMenuProps) => {
    const screenWidth = useWindowSize(); // Screen width
    const [menuOpen, setMenuOpen] = useState<boolean>(false); // Menu toggle flag
    const {filterData} = useFilterContext(); // Filter data
    const [selectedFilters, setSelectedFilters] = useState<string[]>([]); // Currently selected filters

    // Set filters
    const toggleFilter = (value: string) => {
        setSelectedFilters((prev) =>
            prev.includes(value)
                ? prev.filter((f) => f !== value) // Remove
                : [...prev, value] // Add
        );
    };

    // Handle initial load and getting rid of unsubmitted but picked filters
    useEffect(() => {
        if (filterOpen === false) {
            // Close the menu
            setMenuOpen(false)
            // Set only the submitted filters
            const currentFilter = filterData?.[slug];
            const submittedFilters = currentFilter
                ? Object.entries(currentFilter)
                    .filter(([key, val]) => val === true)
                    .map(([key]) => key)
                : [];
            setSelectedFilters(submittedFilters);
        }
    }, [filterOpen, filterData, slug]);

    // Change filter card wide filters
    useEffect(()=>{
        if(setFilters) setFilters(slug, selectedFilters);
    }, [selectedFilters])


    return (
        <>
            <div className={styles.FilterMenu} key={slug}>
                <button className={styles.FilterMenuHeader} onClick={()=>setMenuOpen(!menuOpen)}>
                    <p>{title}</p>
                    {menuOpen === false && (
                        <>
                        {screenWidth > 500 ? (
                            <div className={styles.SelectedFilters}>
                                {selectedFilters.length != 0 && selectedFilters.slice(0, 2).map((filter, i)=>(
                                    <div className={styles.SelectedFilter}><p>{tags.find(tag => tag.slug === filter)?.text}</p></div>
                                ))}
                                {selectedFilters.length > 2 && <div className={styles.SelectedFilter}><p>+{selectedFilters.length-2}</p></div>}
                            </div>
                        ):(
                            <div className={styles.SelectedFilters}>
                                {selectedFilters.length> 0 && <div className={styles.SelectedFilter}><p>+{selectedFilters.length}</p></div>}
                            </div>
                        )}
                        </>
                    )}
                    {menuOpen == true ? <ChevronDown/> : <ChevronUp/>}
                </button>
                <div className={styles.FilterMenuContent} style={menuOpen == false ? { display: "none" } : undefined}>
                    {tags.map((tag, i) => (
                        <FilterOptionCard
                            key={`${tag}-${i}`}
                            value={tag}
                            // Takes slug as key of Filter data props and tag.slug as its keys
                            checked={selectedFilters.includes(tag.slug)}
                            onToggle={() => toggleFilter(tag.slug)}
                        />
                    ))}
                </div>
            </div>
        </>
    )
}
export default FilterMenu;
